module.exports = __webpack_public_path__ + "img/logo-icon.e1d6950b.png";